(function(){
  'use strict';
  if (window.matchMedia && !window.matchMedia('(max-width:749px)').matches) return;

  var C = window.SoulStoneMobileApp || {};
  var q = function(s,r){ return (r || document).querySelector(s); };
  var qa = function(s,r){ return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function(v){ return String(v || '').replace(/[&<>"']/g,function(m){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[m]; }); };

  function icon(name){
    var icons = {
      menu:'<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M4 12h16M4 17h16"/></svg>',
      home:'<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 11.2 12 4l8 7.2v8.3a.8.8 0 0 1-.8.8h-4.8v-5.6H9.6v5.6H4.8a.8.8 0 0 1-.8-.8Z"/><path d="M12 1.8v2.1M2.5 8.6l1.8.8M21.5 8.6l-1.8.8"/></svg>',
      shop:'<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6.2 8.3h11.6l1 12H5.2l1-12Z"/><path d="M9 9V6.4a3 3 0 0 1 6 0V9"/><path d="M12 2.3v1.1"/></svg>',
      designs:'<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m12 3 1.35 4.1L17.5 8.5l-4.15 1.4L12 14l-1.35-4.1L6.5 8.5l4.15-1.4L12 3Z"/><path d="m18.5 13.5.75 2.25L21.5 16.5l-2.25.75L18.5 19.5l-.75-2.25-2.25-.75 2.25-.75.75-2.25Z"/><path d="M5.2 14.8 6 17l2.2.8-2.2.8-.8 2.2-.8-2.2-2.2-.8L4.4 17l.8-2.2Z"/></svg>',
      guidance:'<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="5.2" y="3.2" width="13.6" height="17.6" rx="1.7"/><path d="M12 7.2a3.3 3.3 0 1 0 3.1 4.4A3.8 3.8 0 0 1 12 7.2Z"/><path d="M8.4 17h7.2"/></svg>',
      cart:'<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 4h2l2 10h10.7l2-7.2H6.1"/><circle cx="9" cy="19" r="1.3"/><circle cx="17" cy="19" r="1.3"/></svg>'
    };
    return icons[name] || '';
  }

  function pathOf(url){
    try { return new URL(url,location.origin).pathname.toLowerCase(); }
    catch(e){ return String(url || '').split('?')[0].toLowerCase(); }
  }

  function classifySections(){
    var main = q('#MainContent');
    if (!main) return;

    var sections = Array.prototype.filter.call(main.children,function(el){
      return el.classList && el.classList.contains('shopify-section');
    });

    sections.forEach(function(section,index){
      section.classList.add('ssm-app-section');
      if (index === 0) section.classList.add('ssm-app-section-first');

      if (section.querySelector('.ssc-dg')) {
        section.classList.add('ssm-guidance-section');
      }

      var productCards = section.querySelectorAll('product-card,.product-card,.card-wrapper,.card-product');

      if (productCards.length >= 2) {
        section.classList.add('ssm-product-section','ssm-has-rail');

        var candidates = qa('.product-grid,[data-product-grid],ul.grid,.grid,[class*="product-grid"]',section);
        var rail = candidates.find(function(grid){
          return grid.querySelectorAll('product-card,.product-card,.card-wrapper,.card-product').length >= 2;
        });

        if (rail) rail.classList.add('ssm-horizontal-products');
      } else if (section.querySelector('img,picture') && !section.querySelector('form[action*="/cart"]')) {
        section.classList.add('ssm-feature-section');
      }
    });

    qa('.ssc-dg',main).forEach(function(el){
      el.classList.add('ssm-guidance-feature');
    });

    qa('a.button,button.button,.button',main).forEach(function(el){
      if (!el.closest('.ss-mobile-app')) el.classList.add('ssm-pressable');
    });
  }

  function polishFooter(){
    var footer = q('footer');
    if (footer) footer.classList.add('ssm-footer-polished');
  }

  function fixInnerMenuIcon(){
    var btn = q('.ssm-topbar [data-ssm-menu-open]');
    if (btn) btn.innerHTML = icon('menu');
  }

  function rebuildNav(){
    var nav = q('.ssm-nav');
    if (!nav || !C.root) return;

    var root = C.root || '/';
    var shop = C.shop || '/pages/shop-all';
    var designs = C.designs || '/pages/uv-dtf-dtf';
    var guidance = C.guidance || (root + '?ssapp=guidance');
    var cart = C.cart || '/cart';
    var count = parseInt(C.cartCount,10) || 0;

    nav.innerHTML =
      '<a href="' + esc(root) + '" data-ssm-tab="home">' + icon('home') + '<span>Home</span></a>' +
      '<a href="' + esc(shop) + '" data-ssm-tab="shop">' + icon('shop') + '<span>Shop</span></a>' +
      '<a href="' + esc(designs) + '" data-ssm-tab="designs">' + icon('designs') + '<span>Designs</span></a>' +
      '<a href="' + esc(guidance) + '" data-ssm-tab="guidance" data-ssm-guidance>' + icon('guidance') + '<span>Guidance</span></a>' +
      '<a class="ssm-nav-cart" href="' + esc(cart) + '" data-ssm-tab="cart">' + icon('cart') + '<span>Cart</span><b class="ssm-nav-badge" ' + (count ? '' : 'hidden') + '>' + count + '</b></a>';

    var path = location.pathname.toLowerCase();
    var params = new URLSearchParams(location.search);
    var tab = 'home';

    if (path.indexOf('/cart') === 0) tab = 'cart';
    else if (params.get('ssapp') === 'guidance') tab = 'guidance';
    else if (path === pathOf(designs)) tab = 'designs';
    else if (path !== '/' && path !== '') tab = 'shop';

    var active = nav.querySelector('[data-ssm-tab="' + tab + '"]');
    if (active) {
      active.classList.add('is-active');
      active.setAttribute('aria-current','page');
    }

    var guidanceLink = nav.querySelector('[data-ssm-guidance]');
    if (guidanceLink) {
      guidanceLink.addEventListener('click',function(e){
        var el = q('.ssc-dg');
        if (!el) return;
        e.preventDefault();
        var y = el.getBoundingClientRect().top + window.pageYOffset - 74;
        window.scrollTo({top:y,behavior:'smooth'});
        history.replaceState(null,'',guidance);
      });
    }
  }

  function init(){
    classifySections();
    polishFooter();
    fixInnerMenuIcon();
    rebuildNav();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init);
  else init();

  document.addEventListener('shopify:section:load',function(){
    classifySections();
    polishFooter();
    rebuildNav();
  });
})();